import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AliadoUsuario } from '../../_models/aliado-usuario';

@Component( {
  selector: 'app-aliados-usuarios-detalle',
  templateUrl: 'aliados-usuarios-detalle.component.html'
} )

export class AliadosUsuariosDetalleComponent implements OnInit {

  @Input() aliado: AliadoUsuario;
  @Output() camSeccion: EventEmitter<boolean> = new EventEmitter();

  constructor() {
  }

  ngOnInit(): void {
  }

  regresar() {
    this.camSeccion.emit( false );
  }
}
